import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { buildCycleContext, getApplicableCycleFlags, getDirectCorrelativas, getDirectUnlocks, getFlagStatus } from '../utils/careerLogicExtra.js';

const CorrelativasPanel = ({ selectedId, plan, materias, onClose }) => {
  const data = useMemo(() => {
    if (!selectedId) return null;
    const m = materias[selectedId];
    const ctx = buildCycleContext(materias);
    const directReqs = getDirectCorrelativas(m, materias);
    const flags = getApplicableCycleFlags(m);
    const unlockDirect = getDirectUnlocks(selectedId, plan);
    return { m, ctx, directReqs, flags, unlockDirect };
  }, [selectedId, plan, materias]);

  if (!selectedId || !data) return null;

  const nombre = materias[selectedId]?.nombre || selectedId;

  return (
    <div style={{
      position: 'absolute',
      right: 8,
      top: 56,
      width: 320,
      maxHeight: '70vh',
      overflowY: 'auto',
      background: 'var(--bg-panel)',
      color: 'var(--text-primary)',
      border: '1px solid var(--border-color)',
      borderRadius: 10,
      boxShadow: 'var(--shadow-medium)',
      zIndex: 12,
      padding: 12
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <strong style={{ fontSize: 16 }}>{nombre}</strong>
        <button onClick={onClose} style={{ border: 'none', background: 'transparent', color: 'var(--text-primary)', cursor: 'pointer' }}>✖</button>
      </div>
      <div style={{ marginBottom: 10 }}>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>Requisitos</div>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {data.directReqs.length === 0 && (
            <li style={{ color: 'var(--text-secondary)' }}>Sin correlativas directas</li>
          )}
          {data.directReqs.map((r) => (
            <li key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 0' }}>
              <span>{r.cumplida ? '✔' : '🔒'}</span>
              <span>{r.nombre}</span>
            </li>
          ))}
        </ul>
        {data.flags.length > 0 && (
          <div style={{ marginTop: 8, fontSize: 12, color: 'var(--text-secondary)', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {data.flags.map((flag) => (
              <span key={flag} style={{ padding: '2px 8px', borderRadius: 12, border: '1px solid var(--border-color)' }}>
                {flag}: {getFlagStatus(flag, data.ctx) ? '🔓' : '🔒'}
              </span>
            ))}
          </div>
        )}
      </div>
      <div>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>Desbloquea (directo)</div>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {data.unlockDirect.length === 0 && (
            <li style={{ color: 'var(--text-secondary)' }}>No habilita materias adicionales</li>
          )}
          {data.unlockDirect.map((m) => (
            <li key={m.id} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '4px 0' }}>
              <span>➡</span>
              <span>{m.nombre}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

CorrelativasPanel.propTypes = {
  selectedId: PropTypes.string,
  plan: PropTypes.object.isRequired,
  materias: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

export default CorrelativasPanel;


